import React from 'react'

const FileIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 96 96"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <clipPath id="clip-clip">
          <rect width="96" height="96" />
        </clipPath>
      </defs>
      <g id="clip" clipPath="url(#clip-clip)">
        <g id="pills" transform="translate(-232 -116)">
          <g id="Group_151" data-name="Group 151">
            <line
              id="Line_15"
              data-name="Line 15"
              y2="49"
              transform="translate(256 135)"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
            <line
              id="Line_16"
              data-name="Line 16"
              y2="42"
              transform="translate(272 135)"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
            <line
              id="Line_17"
              data-name="Line 17"
              y2="42"
              transform="translate(288 135)"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
            <line
              id="Line_18"
              data-name="Line 18"
              y2="49"
              transform="translate(304 135)"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
            <path
              id="Path_182"
              data-name="Path 182"
              d="M288,177a8,8,0,0,1-16,0"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
            <path
              id="Path_183"
              data-name="Path 183"
              d="M256,134.74a16,16,0,0,1,32,0"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
            <path
              id="Path_184"
              data-name="Path 184"
              d="M304,184.39a24,24,0,0,1-48,0"
              fill="none"
              stroke="#58595b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default FileIcon
